import React from 'react';
export const SkeletonImage = () => {
    return (<div className="rounded mb-6 w-full h-40 sm:h-64 bg-gray-400"></div>)
}